"use client";
import { ThemeProvider, type ThemeProviderProps } from "next-themes";

export type ColorModeProviderProps = ThemeProviderProps;

export function ColorModeProvider(props: Readonly<ColorModeProviderProps>) {
    return <ThemeProvider attribute="class" disableTransitionOnChange {...props} />;
}
